import { render } from "./About.vue?vue&type=template&id=06f4c8df&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=06f4c8df&scoped=true&lang=css"

import exportComponent from "/Users/dmitriykuptsov/workspace/front-end-development/strangebit.io/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f4c8df"]])

export default __exports__